import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fixed inset-0 bg-dark-100 bg-opacity-70" }


export default /*#__PURE__*/_defineComponent({
  __name: 'AppModalBackdrop',
  setup(__props) {

// eslint-disable-line

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1))
}
}

})